export enum ViewMode {
    Table,
    Card
}
